/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./alert-modal.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./alert-modal.component";
var styles_AlertModalComponent = [i0.styles];
var RenderType_AlertModalComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AlertModalComponent, data: {} });
export { RenderType_AlertModalComponent as RenderType_AlertModalComponent };
export function View_AlertModalComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "div", [["class", "alert alert-success"]], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["Successfully submitted!"]))], null, null); }
export function View_AlertModalComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-alert-modal", [], null, null, null, View_AlertModalComponent_0, RenderType_AlertModalComponent)), i1.ɵdid(1, 49152, null, 0, i2.AlertModalComponent, [], null, null)], null, null); }
var AlertModalComponentNgFactory = i1.ɵccf("app-alert-modal", i2.AlertModalComponent, View_AlertModalComponent_Host_0, {}, {}, []);
export { AlertModalComponentNgFactory as AlertModalComponentNgFactory };
